if (!customElements.get('facet-dropdown')) {
  class FacetDropdown extends HTMLElement {
    constructor() {
      super();

      this.onDocumentClickHandler = this.onDocumentClick.bind(this);
      this.onDocumentKeyupHandler = this.onDocumentKeyup.bind(this);
      this.onSummaryClickHandler = this.onSummaryClick.bind(this);
    }

    connectedCallback() {
      this.summary = this.querySelector('summary');
      this.summary.addEventListener('click', this.onSummaryClickHandler);
      document.addEventListener('click', this.onDocumentClickHandler);
      document.addEventListener('keyup', this.onDocumentKeyupHandler);

      if (this.hasAttribute('data-auto-hide')) {
        this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
          this.updateVisibility.bind(this)
        );
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClickHandler);
      document.removeEventListener('keyup', this.onDocumentKeyupHandler);

      if (this.facetUpdateUnsubscriber) {
        this.facetUpdateUnsubscriber();
      }
    }

    // Gruppen ausblenden, die in der aktuellen Filter-Kombination nur noch
    // eine (oder keine) waehlbare Option bieten und nichts aktiv haben.
    updateVisibility() {
      const enabled = this.querySelectorAll('input[type="checkbox"]:not(:disabled)').length;
      const checked = this.querySelectorAll('input[type="checkbox"]:checked').length;
      this.classList.toggle('hidden', enabled <= 1 && checked === 0);
    }

    get details() {
      return this.querySelector('details');
    }

    onSummaryClick() {
      // Only one dropdown open at a time, like the old shop.
      if (this.details.open) return;
      this.closeSiblings();
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.close();
    }

    onDocumentKeyup(event) {
      if (event.code !== 'Escape') return;
      this.close();
    }

    close() {
      if (this.details && this.details.open) {
        this.details.removeAttribute('open');
      }
    }

    closeSiblings() {
      const scope = this.closest('form') || document;
      scope.querySelectorAll('facet-dropdown').forEach((dropdown) => {
        if (dropdown !== this) dropdown.close();
      });
    }
  }

  customElements.define('facet-dropdown', FacetDropdown);
}
